module.exports = __webpack_public_path__ + "img/nucor-logo.7a124418.jpg";